import { render, staticRenderFns } from "./homeownership.vue?vue&type=template&id=5a78a99a"
import script from "./homeownership.vue?vue&type=script&lang=js"
export * from "./homeownership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports